import { render, staticRenderFns } from "./rolePicker.vue?vue&type=template&id=5162ae1e&scoped=true"
import script from "./rolePicker.vue?vue&type=script&lang=js"
export * from "./rolePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162ae1e",
  null
  
)

export default component.exports